export const faqs = [
  {
    q: '什么是"吃瓜时间线"？我该如何阅读？',
    a: '吃瓜时间线会把一场热瓜按时间顺序拆成多个关键节点，从事件发酵、当事人回应到反转证据逐步推进。阅读时建议先看头条速览把握主线，再进入单篇详情，配合时间轴与证据清单还原来龙去脉。',
  },
  {
    q: '为什么一个瓜会"瓜中瓜"般一再反转？',
    a: '热点事件往往由多方信息拼凑而成，剪辑截取、语境缺失、立场差异都会让片段"看起来像真相"。当新的完整录音或记录流出后，此前结论常被推翻，这正是"瓜中瓜连环反转"的来源。',
  },
  {
    q: '网传的录音、聊天记录截图可信吗？',
    a: '单段录音或截图只能作为线索，不建议当作定论。我们会尽量补充上下文、多角度旁证与时间轴比对，帮助大家判断可信度，但最终仍应以权威渠道与当事人完整声明为准。',
  },
  {
    q: '每日大瓜的内容是怎么整理的？',
    a: '我们的编辑会汇总全网公开讨论、当事人回应与媒体报道，再按事件还原、反转追踪、证据梳理三个维度整理成时间线。内容定位是"娱乐资讯整理"，仅作观点展示，不站队、不评断。',
  },
  {
    q: '我可以投稿爆料或提供线索吗？',
    a: '可以。欢迎通过"关于我们"页面或页脚邮箱与我们联系，投稿时请尽量附上可核实的时间、来源与材料。涉及隐私或未经证实的敏感信息，我们会谨慎处理并做必要脱敏。',
  },
];